
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export const useCountryAnalytics = () => {
  return useQuery({
    queryKey: ["country-analytics"],
    queryFn: async () => {
      // جلب بيانات الفنادق والبلدان
      const { data: hotelsData, error: hotelsError } = await supabase
        .from("hotels")
        .select("country, city, stars");

      if (hotelsError) throw hotelsError;

      // جلب بيانات الجولات السياحية
      const { data: toursData, error: toursError } = await supabase
        .from("tourist_tours")
        .select(`
          *,
          countries(name_ar, name_en),
          cities(name_ar, name_en)
        `);

      if (toursError) throw toursError;

      // تحليل البلدان حسب عدد الفنادق
      const hotelsByCountry = hotelsData.reduce((acc: any, hotel) => {
        const country = hotel.country;
        if (!acc[country]) {
          acc[country] = { hotels: 0, averageStars: 0, cities: new Set() };
        }
        acc[country].hotels += 1;
        acc[country].averageStars += hotel.stars;
        acc[country].cities.add(hotel.city);
        return acc;
      }, {});

      // حساب متوسط النجوم
      Object.keys(hotelsByCountry).forEach(country => {
        hotelsByCountry[country].averageStars = 
          hotelsByCountry[country].averageStars / hotelsByCountry[country].hotels;
        hotelsByCountry[country].cities = hotelsByCountry[country].cities.size;
      });

      // تحليل الجولات حسب البلد
      const toursByCountry = toursData.reduce((acc: any, tour) => {
        const countryName = tour.countries?.name_ar || 'غير محدد';
        const price = parseFloat(String(tour.price)) || 0;
        if (!acc[countryName]) {
          acc[countryName] = { tours: 0, totalValue: 0 };
        }
        acc[countryName].tours += 1;
        acc[countryName].totalValue += price;
        return acc;
      }, {});

      // ترتيب البلدان حسب القيمة
      const topCountries = Object.entries(toursByCountry)
        .map(([country, data]: [string, any]) => ({
          country,
          tours: data.tours,
          totalValue: data.totalValue,
          averagePrice: data.totalValue / data.tours || 0,
          hotels: hotelsByCountry[country]?.hotels || 0
        }))
        .sort((a, b) => b.totalValue - a.totalValue)
        .slice(0, 8);

      return {
        topCountries,
        hotelsByCountry,
        toursByCountry,
        totalCountries: Object.keys(toursByCountry).length
      };
    },
  });
};
